import { render, staticRenderFns } from "./STab.vue?vue&type=template&id=c69c4d7a&scoped=true&"
import script from "./STab.vue?vue&type=script&lang=js&"
export * from "./STab.vue?vue&type=script&lang=js&"
import style0 from "./STab.vue?vue&type=style&index=0&id=c69c4d7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69c4d7a",
  null
  
)

export default component.exports